export var queryKey = 'UserEntitlements';
export var parseConfigKey = 'userEntitlements';
export var userEntitlementsPersistenceKey = 'userEntitlements';
export var userEntitlementsPersistenceVersion = 1;
//# sourceMappingURL=Constants.js.map